module.exports = __webpack_public_path__ + "img/Simplificando-a-Gestao-de-Obras-na-Engenharia-Civil.ac270058.png";